import React, { ReactElement } from 'react';
import TextInput from "./TextInput";

type NameInputProps = {
    id: string,
    name?: string,
    label: string,
    required: boolean,
    maxLength?: number,
    labelContent?: ReactElement,
    children?: React.ReactNode
}

const NameInput = (props: NameInputProps) => {
    const maxLength = props.maxLength ?? 50
    return (
        <TextInput id={props.id} name={props.name} label={props.label} required={props.required}
                   inputMask={{ regex: `^[^\\\\/.]{1,${maxLength}}$` }}
                   labelContent={props.labelContent}
                   maxLength={maxLength}
                   validate={(value) => validateFirstNameNumber(value, maxLength)}/>
    )

    function validateFirstNameNumber(value: string, maxLength: number) {
        const regExp = new RegExp(`^[^\\\\/.]{1,${maxLength}}$`, "gi");
        return regExp.test(value) ? '' : `Name must be ${maxLength} characters or fewer.`
    }
};

export default NameInput;